import React from 'react'

const Logo: React.FC = () => {
    return (
        <svg
            height="48px"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 400 400"
        >
            <g>
                <path
                    fill="#2d2d2d"
                    d="M363,366.1V24.4c0-8.1-6.5-14.6-14.6-14.6H50.7c-8.1,0-14.6,6.5-14.6,14.6v61.4l212.5,62.1
                        c9.1,2.7,15.4,11,15.4,20.5v1.4c0,7.6-3.7,14.8-10,19.1c-20.8,14.3-69.3,44-91.1,57.2c-4.8,2.9-4.7,10,0.3,12.7L363,366.1z"
                />
                <path
                    fill="#2d2d2d"
                    d="M226.1,168.3c3.4,1,3.9,5.6,0.9,7.4l-92.1,53.6c-8.7,5-14.1,14.3-14.1,24.4v0c0,10.4,5.8,20,15,24.8
                        l209.6,110.7H50.7c-8.1,0-14.6-6.5-14.6-14.6V109.9L226.1,168.3z"
                />
            </g>
        </svg>
    )
}

export default Logo
